import styled from '@emotion/styled'
import {theme} from '../../../../accountManagement/theme'

// Only what the shared components don't already provide. Catalog surfaces come
// from AccountSetup.styles / PurchaseLink ProductsCatalog.styles, the summary
// from features/OrderSummary, the country field from CountrySelector.

// Outer wrapper for the 1:Many flow page only.
export const ManyLinkFlowWrapper = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  gap: 16px;
  // padding: 10px 40px;
`

// Controls inside the summary's footer slot (Generate Link etc.). The slot
// (SummaryActionsSlot) supplies the padding and the frame supplies the
// gradient/border, so this is layout only.
export const SummaryActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.space[3]};
`

export const ConfirmBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(17, 24, 39, 0.45);
  z-index: ${theme.zIndex.modal};
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ConfirmDialog = styled.div`
  width: min(420px, calc(100vw - 32px));
  background: #fff;
  border-radius: 16px;
  padding: ${theme.space[6]};
  box-shadow: ${theme.shadows.lg};
  font-family: ${theme.fonts.openSans};

  h3 {
    margin: 0 0 ${theme.space[2]};
    font-size: ${theme.fontSizes.xl};
    font-weight: ${theme.fontWeights.bold};
  }
  p {
    margin: 0 0 ${theme.space[5]};
    font-size: ${theme.fontSizes.base};
    color: ${theme.palette.neutral[600]};
    line-height: 1.4;
  }
  .actions {
    display: flex;
    justify-content: flex-end;
    gap: ${theme.space[2]};
  }
`
